import customAxios from "../../../http/customAxios";

export type GetRevenuesByFunctionalityQueryResult = {
  hotelTicker: string;
  tag: string;
  totalReservations: number;
  totalRevenue: number;
};

type GetRevenuesByFunctionalityQueryRequest = {
  functionalities: string[];
  startDate: string;
  endDate: string;
  hotelTickers: string[];
};

export async function getRevenuesByFunctionality(
  queryExecutorApiEndpoint: string,
  { functionalities, startDate, endDate, hotelTickers }: GetRevenuesByFunctionalityQueryRequest
): Promise<GetRevenuesByFunctionalityQueryResult[]> {
  const queryJSON = {
    sql: `
      WITH RECURSIVE split_tags AS (
          -- Base case: get first tag and rest
          SELECT
              hotelTicker,
              amount,
              SUBSTRING_INDEX(tags, ',', 1) AS tag,
              SUBSTRING(tags, LENGTH(SUBSTRING_INDEX(tags, ',', 1)) + 2) AS rest
          FROM reports.booking
          WHERE
              hotelTicker IN (@hotelTickers)
            AND bookingDate BETWEEN DATE @startDate AND DATE @endDate
            AND status = @status
            AND tags IS NOT NULL
            AND tags != ''
      UNION ALL
          -- Recursive step: split the remaining tags
          SELECT
              hotelTicker,
              amount,
              SUBSTRING_INDEX(rest, ',', 1) AS tag,
              SUBSTRING(rest, LENGTH(SUBSTRING_INDEX(rest, ',', 1)) + 2) AS rest
          FROM split_tags
          WHERE rest IS NOT NULL AND rest != ''
      )
      SELECT
          hotelTicker,
          tag,
          COUNT(*) AS totalReservations,
          SUM(amount) AS totalRevenue
      FROM split_tags
      WHERE tag IS NOT NULL AND tag != '' AND tag IN (@availableTags)
      GROUP BY hotelTicker, tag
      ORDER BY hotelTicker, tag;
    `,
    onlyLiveProperties: false,
    excludeChains: false,
    context: {
      "@hotelTickers": hotelTickers,
      "@startDate": startDate,
      "@endDate": endDate,
      "@status": "reserva",
      "@availableTags": functionalities,
    },
  };

  const response = await customAxios.post<{ result: GetRevenuesByFunctionalityQueryResult[] }>(
    queryExecutorApiEndpoint,
    queryJSON
  );
  return response.data.result;
}
